<template>
  <!-- 订单详情物流列表 -->
  <div v-if="trackBean && trackBean !== null" class="log_con">
    <div class="font12 font_weight400 colo038 line_height_17 text_left">
      物流公司：<span class="colo087">{{ trackBean.companyName }}</span>
    </div>
    <div
      class="order_id font12 font_weight400 colo038 line_height_20 text_left"
    >
      <div>
        物流单号：<span class="colo087">{{ trackBean.trackingNo }}</span>
      </div>
      <div
        v-clipboard:copy="trackBean.trackingNo"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 colo087 copy_id"
      >
        复制
      </div>
    </div>
    <div
      v-if="trackBean.trackingDataList && trackBean.trackingDataList.length"
      class="list"
    >
      <div
        v-for="(i, index) in trackBean.trackingDataList"
        :key="index"
        class="list_item text_left"
      >
        <div
          v-if="index !== trackBean.trackingDataList.length - 1"
          :class="{ left_line_bg: index !== 0 }"
          class="left_line"
        ></div>
        <img
          v-if="
            index === 0 ||
              index === trackBean.trackingDataList.length - 1 ||
              index === trackBean.trackingDataList.length - 2
          "
          :src="
            index === 0
              ? indexImg
              : index === trackBean.trackingDataList.length - 2
              ? buyedImg
              : payedImg
          "
          alt=""
          class="list_icon"
        />
        <div v-else class="round_step"></div>
        <div class="item_det">
          <div
            v-html="judge(i.context, i.phone)"
            class="font12 font_weight400 colo087"
          ></div>
          <div v-if="i.status !== 1" class="11 font12 colo055">
            {{ i.time }}
          </div>
          <div v-if="i.status === 1" class="11 font12 colo055">
            {{ i.time | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    trackBean: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      payedImg: require("@/assets/order/payed@2x.png"),
      buyedImg: require("@/assets/order/buyed@2x.png"),
      indexImg: require("@/assets/login/select@2x.png")
    };
  },
  methods: {
    onCopy() {
      this.$toast("运单号已复制到剪贴板！");
    },
    onError() {
      this.$toast("复制失败，请重试！");
    },
    judge(str, cond) {
      if (!str) return "";
      if (!cond) {
        return str;
      }
      var reg = new RegExp(cond, "g");
      return str.replace(reg, `<a href="tel:${cond}">${cond}</a>`);
    }
  }
};
</script>

<style lang="less" scoped>
.log_con {
  background: #fff;
  margin-top: 12px;
  padding: 16px 12px 16px 16px;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 4px;
    .copy_id {
      padding: 0 8px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.38);
    }
  }
  .list {
    margin-top: 18px;
    margin-left: 20px;
    .list_item {
      display: flex;
      font-size: 0;
      position: relative;
      .list_icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        position: absolute;
        top: 0px;
        left: -12px;
      }
      .item_det {
        width: 270px;
        padding: 0 0 24px 23px;
      }
      .round_step {
        width: 4px;
        height: 4px;
        background: #ddd;
        border: 2px solid #fff;
        border-radius: 50%;
        position: absolute;
        top: 4px;
        left: -2px;
      }
      .left_line {
        width: 1px;
        background: linear-gradient(
          180deg,
          rgba(255, 12, 19, 1) 0%,
          rgba(221, 221, 221, 1) 100%
        );
        margin: 15px 0 0 0;
      }
      .left_line_bg {
        background: rgba(221, 221, 221, 1) !important;
      }
    }
  }
}
</style>
